import AddProposal from "../components/AddProposal";
import React from "react";



export default function CreateProposal() {
  return (
    <div>
      <div className="container">
        <div className="row">
          <div
            className="col-lg-4"
            style={{
              maxWidth: 600,
              display: "flex",
              justifyContent: "center",
              margin: "0 auto",
            }}
          >

            <AddProposal />
          </div>
        </div>
      </div>
    </div>
  );
}
